import React, { useState, useEffect } from 'react'
import { useParams, useLocation } from 'react-router-dom'
// import queryString from 'query-string'
import AuthService from '../../services/auth.service'
import { Typography } from '@mui/material'
import PreLogin from '../../layout/preLogin'
import { Loader } from '../../components'
import { ROUTE_PROJECTS } from '../../constants'
import { useGlobalStore } from '../../store'
import jwt_decode from 'jwt-decode'
import { Heading, ErrorMsg, LinkButton } from './style'

const Authorize = (props) => {
  const { companyId } = useParams()
  const { setUser, setCompany } = useGlobalStore()

  const [loader, setLoader] = useState(true)
  const [serverErrorMsg, setServerErrorMsg] = useState()

  const getTokenDetails = async () => {
    // console.log('access_token, token_type === ', access_token, token_type)
    // const tempToken = access_token || 'eyJraWQiOiI4NGE1NjljM2FkNDBmYjU0NmJlNmU0ODNmNGM5N2JjYiIsInR5cCI6IkpXVCIsImFsZyI6IlJTMjU2In0.eyJhdXRobl9wcm92aWRlciI6Ik1JRFdBWSIsImF1ZCI6Imh0dHBzOi8vaW5zaWdodHNhc3Npc3RhbnQubWF2ZW5tYWduZXQuY29tIiwic3ViIjoic29ucGFnZUBhbWF6b24uY29tIiwibmJmIjoxNjg2MzI4NTkwLCJpc3MiOiJodHRwczovL2lkcC5mZWRlcmF0ZS5hbWF6b24uY29tIiwicHJlZmVycmVkX3VzZXJuYW1lIjoic29ucGFnZSIsImV4cCI6MTY4NjMyOTQ5MCwiZmVkZXJhdGVfdG9rZW5fcHVycG9zZSI6ImFjY2Vzc190b2tlbiIsImlhdCI6MTY4NjMyODU5MH0.TV2NIx_0l5FsyhY2qma1EPPerOH_G_YsLRR1W-k7Lwxtzc_4f2qU01Tj7NOtHVKJzPLXl-u1XEU8xi3H0_uzxAL8SI2vgDlKakW6RV4v3E1vCS9XhJ_8g1WHnT4m19cLodc7QKs0_YZZ0VwWh7rGV0YUviBhCo-ZloaP_trgdUD4qIpna1-KaVLBOS8mOAjKC1PLViPiLc7rLHTQTSzuTLR39b0X0qy0ifoxRnjOygjVTnacgEAJCd0Dve5yrru0aT1UWsf7EAdI6MOdWOmgKDisY0QE5OIjm0CD0qV0Grjx3I1DBs_rBqKiUKEFVyYDzDPy3fqhnO9mlKVA9N2TCg'

    // https://insightsassistant.mavenmagnet.com/authorize/15a8a391-a31b-11ed-817c-0a1ea4c5532f#access_token=eyJraWQiOiI4NGE1NjljM2FkNDBmYjU0NmJlNmU0ODNmNGM5N2JjYiIsInR5cCI6IkpXVCIsImFsZyI6IlJTMjU2In0.eyJhdXRobl9wcm92aWRlciI6Ik1JRFdBWSIsImF1ZCI6Imh0dHBzOi8vaW5zaWdodHNhc3Npc3RhbnQubWF2ZW5tYWduZXQuY29tIiwic3ViIjoic29ucGFnZUBhbWF6b24uY29tIiwibmJmIjoxNjg2MzI4NTkwLCJpc3MiOiJodHRwczovL2lkcC5mZWRlcmF0ZS5hbWF6b24uY29tIiwicHJlZmVycmVkX3VzZXJuYW1lIjoic29ucGFnZSIsImV4cCI6MTY4NjMyOTQ5MCwiZmVkZXJhdGVfdG9rZW5fcHVycG9zZSI6ImFjY2Vzc190b2tlbiIsImlhdCI6MTY4NjMyODU5MH0.TV2NIx_0l5FsyhY2qma1EPPerOH_G_YsLRR1W-k7Lwxtzc_4f2qU01Tj7NOtHVKJzPLXl-u1XEU8xi3H0_uzxAL8SI2vgDlKakW6RV4v3E1vCS9XhJ_8g1WHnT4m19cLodc7QKs0_YZZ0VwWh7rGV0YUviBhCo-ZloaP_trgdUD4qIpna1-KaVLBOS8mOAjKC1PLViPiLc7rLHTQTSzuTLR39b0X0qy0ifoxRnjOygjVTnacgEAJCd0Dve5yrru0aT1UWsf7EAdI6MOdWOmgKDisY0QE5OIjm0CD0qV0Grjx3I1DBs_rBqKiUKEFVyYDzDPy3fqhnO9mlKVA9N2TCg&token_type=bearer&expires_in=900
    // localhost:8080/authorize/15a8a391-a31b-11ed-817c-0a1ea4c5532f#access_token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyIkX18iOnsic3RyaWN0TW9kZSI6dHJ1ZSwic2VsZWN0ZWQiOnt9LCJnZXR0ZXJzIjp7fSwiX2lkIjoiNjNlMGRlN2RmMmVjNjIxN2MwODlhNjJmIiwid2FzUG9wdWxhdGVkIjpmYWxzZSwiYWN0aXZlUGF0aHMiOnsicGF0aHMiOnsiZW1haWwiOiJpbml0Iiwicm9sZSI6ImluaXQiLCJfaWQiOiJpbml0IiwibmFtZSI6ImluaXQiLCJwYXNzd29yZCI6ImluaXQiLCJjb21wYW55SWQiOiJpbml0IiwiY3JlYXRlZEF0IjoiaW5pdCIsInVwZGF0ZWRBdCI6ImluaXQiLCJfX3YiOiJpbml0IiwiZmlyc3ROYW1lIjoiaW5pdCIsImxhc3ROYW1lIjoiaW5pdCIsInVwZGF0ZWRCeSI6ImluaXQiLCJzaWduYXR1cmUiOiJpbml0In0sInN0YXRlcyI6eyJpZ25vcmUiOnt9LCJkZWZhdWx0Ijp7fSwiaW5pdCI6eyJfaWQiOnRydWUsIm5hbWUiOnRydWUsImVtYWlsIjp0cnVlLCJwYXNzd29yZCI6dHJ1ZSwicm9sZSI6dHJ1ZSwiY29tcGFueUlkIjp0cnVlLCJjcmVhdGVkQXQiOnRydWUsInVwZGF0ZWRBdCI6dHJ1ZSwiX192Ijp0cnVlLCJmaXJzdE5hbWUiOnRydWUsImxhc3ROYW1lIjp0cnVlLCJ1cGRhdGVkQnkiOnRydWUsInNpZ25hdHVyZSI6dHJ1ZX0sIm1vZGlmeSI6e30sInJlcXVpcmUiOnt9fSwic3RhdGVOYW1lcyI6WyJyZXF1aXJlIiwibW9kaWZ5IiwiaW5pdCIsImRlZmF1bHQiLCJpZ25vcmUiXX0sInBhdGhzVG9TY29wZXMiOnt9LCJjYWNoZWRSZXF1aXJlZCI6e30sInNlc3Npb24iOm51bGwsIiRzZXRDYWxsZWQiOnt9LCJlbWl0dGVyIjp7Il9ldmVudHMiOnt9LCJfZXZlbnRzQ291bnQiOjAsIl9tYXhMaXN0ZW5lcnMiOjB9LCIkb3B0aW9ucyI6eyJza2lwSWQiOnRydWUsImlzTmV3IjpmYWxzZSwid2lsbEluaXQiOnRydWUsImRlZmF1bHRzIjp0cnVlfX0sImlzTmV3IjpmYWxzZSwiJGxvY2FscyI6e30sIiRvcCI6bnVsbCwiX2RvYyI6eyJfaWQiOiI2M2UwZGU3ZGYyZWM2MjE3YzA4OWE2MmYiLCJuYW1lIjoiU3VsYW1hbiIsImVtYWlsIjoic3VsYW1hbndhZGlAZ21haWwuY29tIiwicGFzc3dvcmQiOiIkMmEkMDgkRk5UTzR5Z3dEWU9OWkVsSHlINXB4T1RCLkI4UFd1ay81eWpwQ0ZKaTdzeS9Va3paWXFyMGEiLCJyb2xlIjoiYWRtaW4iLCJjb21wYW55SWQiOiI2M2I5ODAxNzMzZGMyMzY0NzAwMzcxMjEiLCJjcmVhdGVkQXQiOiIyMDIzLTAyLTA2VDExOjAzOjI4LjQzMloiLCJ1cGRhdGVkQXQiOiIyMDIzLTA1LTIwVDE4OjU4OjM0LjcyMFoiLCJfX3YiOjAsImZpcnN0TmFtZSI6IlN1bGFtYW4iLCJsYXN0TmFtZSI6IldhZGl3YWxhIiwidXBkYXRlZEJ5IjoiNjNlMGRlN2RmMmVjNjIxN2MwODlhNjJmIiwic2lnbmF0dXJlIjoiPHA-VGhhbmtzIGFuZCBSZWdhcmRzLDxicj5TdWxhbWFuIFdhZGl3YWxhPGJyPk1vYmlsZTogOTgzMzUwODU2ODwvcD4ifSwiJGluaXQiOnRydWUsInRpbWUiOiJNb24gSnVuIDEyIDIwMjMgMTU6MTU6MTkgR01UKzA1MzAgKEluZGlhIFN0YW5kYXJkIFRpbWUpIiwidXNlcklkIjoxMiwiaWQiOiI2M2UwZGU3ZGYyZWM2MjE3YzA4OWE2MmYiLCJjaWQiOiI2M2I5ODAxNzMzZGMyMzY0NzAwMzcxMjEiLCJyb2xlIjoiYWRtaW4ifQ.ZDWxQae21cLgKf676cBHy1Zzlo_5ps6ne0EjUtQzeqY"&token_type=bearer&expires_in=900

    // [09:03, 11/10/2023] Aditya - MavenMagnet: SSOLoginUrl: https://idp.federate.amazon.com/api/oauth2/v1/authorize?response_type=token&client_id=https://insightsassistant.mavenmagnet.com&redirect_uri=https://insightsassistant.mavenmagnet.com/authorize/15a8a391-a31b-11ed-817c-0a1ea4c5532f&scope=openid+email+phone+profile
    // [09:03, 11/10/2023] Aditya - MavenMagnet: SSOSecret: WgAUjvKkdfYYU1HMASlZUZakeSSyBxNhdN4G3EMRe6gA
    // SSOLoginUrl: https://idp.federate.amazon.com/api/oauth2/v1/authorize?response_type=token&client_id=https://insightsassistant.mavenmagnet.com&redirect_uri=https://insightsassistant.mavenmagnet.com/authorize/[MM CompanyId]&scope=openid+email+phone+profile

    const url = window.location.href.split('#access_token=')[1].split('&')
    const token = jwt_decode(url[0])

    loginUsingToken(token)
  }

  const loginUsingToken = (token) => {
    console.log('token ', token)
    // {
    //   "authn_provider": "MIDWAY",
    //   "aud": "https://insightsassistant.mavenmagnet.com",
    //   "sub": "sonpage@amazon.com",
    //   "nbf": 1686328590,
    //   "iss": "https://idp.federate.amazon.com",
    //   "preferred_username": "sonpage",
    //   "exp": 1686329490,
    //   "federate_token_purpose": "access_token",
    //   "iat": 1686328590
    // }

    const resp = {
      email: token?.sub,
      companyId: companyId, // AMAZON Company ID
    }

    AuthService.getSSOUserApi(resp)
      .then((resp) => {
        if (resp?.user?.UserId) {
          setUser(resp.user)
          setCompany(resp.company)
          props.history.push(ROUTE_PROJECTS)
        } else {
          setServerErrorMsg(
            'You do not have access to Insights Assistant. Please contact your administrator to get access.'
          )
        }
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
      .finally(() => {
        setLoader(false)
      })
  }

  useEffect(() => {
    getTokenDetails()
  }, [])

  useEffect(() => {
    localStorage.setItem('logs', JSON.stringify([]))
    localStorage.setItem('company', JSON.stringify({}))
    localStorage.setItem('user', JSON.stringify({}))
  }, [])

  return (
    <>
      <PreLogin>
        <Heading type={serverErrorMsg}>
          <Typography color='textPrimary'>
            Authorization {serverErrorMsg ? 'Failed' : 'Page'}
          </Typography>
        </Heading>
        {loader && <Loader width={50} />}
        {serverErrorMsg && <ErrorMsg>{serverErrorMsg}</ErrorMsg>}
        <LinkButton href='/login'>Return in sign in</LinkButton>
      </PreLogin>
    </>
  )
}

export default Authorize
